//  React TS Helper Functions
import pxToRem from '../../functions/pxToRem'

// types
type Types = any

const step: Types = {
  styleOverrides: {
    root: {
      padding: `0 ${pxToRem(6)}`,
    },
  },
}

export default step
